import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { AnonymousIdService } from '@core/services/anonymous-id.service';
import { environment } from '@environments/environment';

export const anonymousInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    // Solo agrega el header a peticiones hacia el insights service
    if (!req.url.startsWith(environment.INSIGHTS_URL)) return next(req);

    const anonymousIdService = inject(AnonymousIdService);
    const anonymousId = anonymousIdService.getOrCreate();

    // Si estamos en SSR no hay localStorage, se omite el header
    if (!anonymousId) return next(req);

    const clonedReq = req.clone({
        setHeaders: {
            'x-anonymous-id': anonymousId
        }
    });

    return next(clonedReq);
};
